import axios from 'axios';
import authHeader from '../auth-header';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";
import tokenHeader from '../token-header';
// const API_URL = 'https://localhost:9090 /api/all/ ';


const getCabang = 'cabang';
const postCabangUrl = 'cabang';
const putCabang = 'cabang/';
const deleteCabang = 'cabang/';
const exportCabang = 'data-cabang-export';

class CabangService {
    getCabang(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getCabang + '?pageNo=' + currentPage + '&pageSize='+pageSize + '&filter='+filter,
            {
                headers: authHeader()
            });
    }

    postCabang(formData) {        
        return axios
        .post(
            API_URL + postCabangUrl,
            formData,
            { headers: authHeader() }
        );
    }

    putCabang(formData) {
        var headers = authHeader(); 

        return axios
        .put(
            API_URL + putCabang + formData.idCabang, formData,
            { headers: authHeader() }
        );
    }

    deleteCabang(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteCabang + formData.idCabang,
                { headers: authHeader() }
            );
    }

    exportCabang() {
        return axios.get(API_URL + exportCabang, {
            headers: authHeader(),
            responseType: 'blob'
        });
    }

}

export default new CabangService();